import analyticsApi from "../../../src/api/analytics/analyticsApi"
import type { AnalyticsEstimate } from "../analytics/analyticsApi"

const sendEstimate = (ecommerce: AnalyticsEstimate) => {
  window.dataLayer = window.dataLayer || ([] as unknown[])
  window.dataLayer.push({ event: "quote_save", value: ecommerce.value, product_type: ecommerce.product_type })
}

const analyticsEstimate = async (receiptNo: string) => {
  if (receiptNo === null) {
    return
  }

  const result = await analyticsApi.getEstimate(receiptNo)
  if (result.isError) {
    return
  }

  sendEstimate(result.data)
}

export default analyticsEstimate
